/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The LatestVersionQueryForm model module.
   * @module textbook/model/LatestVersionQueryForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>LatestVersionQueryForm</code>.
   * @alias module:textbook/model/LatestVersionQueryForm
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>LatestVersionQueryForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/LatestVersionQueryForm} obj Optional instance to populate.
   * @return {module:textbook/model/LatestVersionQueryForm} The populated <code>LatestVersionQueryForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'author')) {
        obj['author'] = ApiClient.convertToType(data['author'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producerCompanyId')) {
        obj['producerCompanyId'] = ApiClient.convertToType(data['producerCompanyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publisherCompanyId')) {
        obj['publisherCompanyId'] = ApiClient.convertToType(data['publisherCompanyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'eduStage')) {
        obj['eduStage'] = ApiClient.convertToType(data['eduStage'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'auditStatus')) {
        obj['auditStatus'] = ApiClient.convertToType(data['auditStatus'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'onlineStatus')) {
        obj['onlineStatus'] = ApiClient.convertToType(data['onlineStatus'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 书名
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 作者 查询chiefEditor｜ deputyEditor ｜contributingAuthors
   * @member {String} author
   */
  exports.prototype['author'] = undefined;
  /**
   * 制作单位id
   * @member {Integer} producerCompanyId
   */
  exports.prototype['producerCompanyId'] = undefined;
  /**
   * 出版社id
   * @member {Integer} publisherCompanyId
   */
  exports.prototype['publisherCompanyId'] = undefined;
  /**
   * 1中职，2高职，3 中高职
   * @member {Integer} eduStage
   */
  exports.prototype['eduStage'] = undefined;
  /**
   * 当前审核状态 0待上传1上传完毕待审核  2 审核通过  -1撤回 -2审核不通过
   * @member {Integer} auditStatus
   */
  exports.prototype['auditStatus'] = undefined;
  /**
   * 当前上线状态 1上线 0未上线
   * @member {Integer} onlineStatus
   */
  exports.prototype['onlineStatus'] = undefined;



  export default exports;
;


